<template>
  <div class="devOpsPublicCom" v-loading="$store.state.user.loadingState">
    <div class="headerTab">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          :label="v.name + '记录'"
          v-for="v in headerList"
          :key="v.name"
          :name="v.name"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="devOpsContent">
      <div
        class="analyseBox ashComWrap"
        :style="{
          height: activeName == '工单' || activeName == '告警' ? '35%' : '25%',
        }"
      >
        <div class="comTitle">
          <h4>{{ activeName }}分析</h4>
        </div>
        <div class="comContentBox">
          <CardListCom
            v-if="
              activeName == '巡检' ||
              activeName == '保养' ||
              activeName == '保洁'
            "
            :cardList="cardList"
          />
          <TopAnalysis v-else :activeName="activeName" :system="system" />
        </div>
      </div>
      <div
        class="notesBox ashComWrap"
        :style="{
          height: activeName == '工单' || activeName == '告警' ? '64%' : '74%',
        }"
      >
        <div class="comTitle">
          <h4>{{ activeName }}记录</h4>
        </div>
        <div class="comContentBox">
          <TablePublicCom :activeName="activeName" :system="system" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardListCom from "./CardListCom.vue";
import TopAnalysis from "./TopAnalysis.vue";
import TablePublicCom from "./TablePublicCom.vue";
import api from "@/api";
export default {
  props: ["system"],
  components: {
    CardListCom,
    TopAnalysis,
    TablePublicCom,
  },
  data() {
    return {
      headerList: [],
      activeName: "",
      cardList: [],
    };
  },
  methods: {
    handleClick(tab, event) {
      let arr = [
        { key: "todayActed", key1: "todayUnActed" },
        { key: "monthActed", key1: "monthUnActed" },
        { key: "yearActed", key1: "yearUnActed" },
        { key: "totalActed", key1: "totalUnActed" },
      ];
      if (this.activeName == "巡检") {
        let newArr = [
          { name: "今日巡检/未巡检" },
          { name: "本月巡检/未巡检" },
          { name: "今年巡检/未巡检" },
          { name: "累积巡检/未巡检" },
        ];
        this.cardList = handelCardList(newArr);
        this.getPatrolTol();
      } else if (this.activeName == "保洁") {
        let newArr = [
          { name: "今日保洁/未保洁" },
          { name: "本月保洁/未保洁" },
          { name: "今年保洁/未保洁" },
          { name: "累积保洁/未保洁" },
        ];
        this.cardList = handelCardList(newArr);
      } else if (this.activeName == "保养") {
        let newArr = [
          { name: "今日保养/未保养" },
          { name: "本月保养/未保养" },
          { name: "今年保养/未保养" },
          { name: "累积保养/未保养" },
        ];
        this.cardList = handelCardList(newArr);
        this.getPatrolTol();
      }

      function handelCardList(newData) {
        let newA = Array.from(arr).map((v, i) => ({
          name: newData[i].name,
          value: "",
          data: "",
          unValue: "",
          key: v.key,
          key1: v.key1,
        }));
        return newA;
      }
    },
    getHeaderList() {
      if (this.$route.path == "/dynamicalDevOps") {
        this.headerList = [
          { name: "巡检" },
          { name: "工单" },
          { name: "告警" },
          // { name: "保洁" },
          { name: "保养" },
        ];
      } else {
        this.headerList = [
          { name: "巡检" },
          { name: "工单" },
          { name: "告警" },
        ];
      }
    },
    /************ 巡检记录 ***********/
    async getPatrolTol() {
      let res = await api.devOpsPatrolTolList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.system,
        sourceType: this.activeName == "巡检" ? "INSPECTION" : "MAINTENANCE",
      });
      if (res && res.data.code == 200) {
        this.cardList.map((v) => {
          v.data = res.data.data[v.key];
          v.unValue = res.data.data[v.key1];
          v.value = `${v.data}/${v.unValue}`;
        });
      }
    },
  },
  created() {
    this.getHeaderList();
    this.activeName = this.$route.params.id ?? "巡检";
    this.handleClick();
  },
};
</script>

<style lang="scss" scoped>
.devOpsPublicCom {
  @include setPage;
  .headerTab {
    width: 100%;
    height: 52px;
    ::v-deep .el-tabs__nav {
      background: #fff;
      .el-tabs__item.is-active {
        background: #28cccb;
        color: #fff;
      }
    }
  }
  .devOpsContent {
    width: 100%;
    height: calc(100% - 52px);
    // background: salmon;
    @include setFlexColumn;
    justify-content: space-between;
    .analyseBox {
      width: 100%;
    }
    .notesBox {
      width: 100%;
    }
  }
}
</style>
